exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lfp-container.container{max-width:100%!important}.container--fluid,.lfp-container.container{padding:0!important;margin:0!important}.fill-height{height:100vh!important}.v-content__wrap,.v-main__wrap{padding:0!important}", ""]);

// exports
